import { FormEvent, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { DefaultModal } from "../../common/modals/default-modal/default-modal";
import { ButtonWithSpinner } from "../../common/button-with-spinner/button-with-spinner";
import defaultStyles from "../../common/modals/default-modal/default-modal.less";
import { resources } from "@constants/hardcoded-strings";
import { ButtonTypes } from "@enums/button-types";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { useDispatch } from "react-redux";
import { FormattedWorkflowConfiguration } from "@idw-types/data/workflow-configuration";
import { EntityStatusTypes } from "@enums/entity-status-types";
import { replaceWorkflowConfiguration } from "@redux/actions/workflows-actions";
import { ModalSizeTypes } from "@enums/modal-size-types";
import { archiveWorkflowRequest } from "@requests/service-configuration";

type ArchiveVerificationWorkflowModalProps = {
    onModalClose: () => void;
    workflowConfiguration: FormattedWorkflowConfiguration;
};

export const ArchiveVerificationWorkflowModal = (props: ArchiveVerificationWorkflowModalProps) => {
    const dispatch = useDispatch();
    const { onModalClose, workflowConfiguration } = props;

    const [requestInProgress, setRequestInProgress] = useState(false);

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
        setRequestInProgress(true);
        const { data, error } = await archiveWorkflowRequest(workflowConfiguration.id);
        if (data) {
            displaySuccessModal(
                dispatch,
                resources.requests.archiveWorkflow.success.title,
                resources.requests.archiveWorkflow.success.message
            );

            const newWorkflowConfiguration: FormattedWorkflowConfiguration = {
                ...workflowConfiguration,
                permissions: {
                    ...workflowConfiguration.permissions,
                    canArchive: false,
                    canRestore: true
                },
                changeRequestID: null,
                changeRequestStatus: null,
                changeRequestType: null,
                status: EntityStatusTypes.INACTIVE
            };

            dispatch(replaceWorkflowConfiguration(newWorkflowConfiguration));
            onModalClose();
        } else {
            if (error) {
                logAndDisplayErrorModal(
                    dispatch,
                    error,
                    resources.requests.archiveWorkflow.error.title,
                    resources.requests.archiveWorkflow.error.message,
                    error
                );
            }
            setRequestInProgress(false);
        }
    };

    return (
        <DefaultModal
            automationId="archive-verification-workflow-modal"
            ariaLabelledBy="archive-verification-workflow-title"
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
            size={ModalSizeTypes.MEDIUM}
        >
            <Form onSubmit={handleSubmit}>
                <Modal.Header id={"archive-verification-workflow-title"} closeButton>
                    <Modal.Title>{resources.modals.archiveVerificationWorkflow.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className={defaultStyles.description}>
                        {resources.modals.archiveVerificationWorkflow.description}
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onModalClose}>{resources.common.buttons.cancel.label}</Button>
                    <ButtonWithSpinner
                        disabled={requestInProgress}
                        hideSpinner={false}
                        variant="primary"
                        type={ButtonTypes.SUBMIT}
                        label={resources.modals.archiveVerificationWorkflow.buttons.archiveWorkflow.label}
                    />
                </Modal.Footer>
            </Form>
        </DefaultModal>
    );
};